import { CareGiversSliceState, InterviewSliceState, ProcessingPaymentSliceState, ProfileSliceState, PurchaseSessionSliceState, ServiceSliceState, StripeSliceState } from "../types/store";
import profileReducer from './profile/slice';
import stripeReducer from "./stripe/slice";
import purchaseSessionReducer from './purchaseSession/slice';
import serviceReducer from './service/slice';
import caregiversReducer from './caregivers/slice';
import interviewReducer from './interview/slice';
import processingPaymentsReducer from './processingPayment/slice';

export type StoreState = {
  profile: ProfileSliceState;
  stripe: StripeSliceState;
  purchaseSession: PurchaseSessionSliceState;
  service: ServiceSliceState;
  caregivers: CareGiversSliceState;
  interview: InterviewSliceState;
  processingPayments: ProcessingPaymentSliceState;
}

const rootReducer = {
  profile: profileReducer,
  stripe: stripeReducer,
  purchaseSession: purchaseSessionReducer,
  service: serviceReducer,
  caregivers: caregiversReducer,
  interview: interviewReducer,
  processingPayments: processingPaymentsReducer, 
};

export default rootReducer;